export default {
  login: {
    title: 'Welcome to',
    noAccountPrompt: 'Don’t have an account? Email us at',
    getStartedPrompt: 'to get started.',
    tooManyAttempts: 'Too many sign-in attempts. Please wait a few seconds and try again.',
  },
  register: {
    title: 'Welcome to',
    subtitle: {
      register: 'Set your account details',
      inviteAccept: 'Click continue to accept your invitation to organisation "{organisation}"',
    },
    passwordReqs: {
      title: 'Your password must',
      min: 'Contain at least 8 characters, with no spaces',
      max: 'Contain no more than 64 characters',
      uppercase: 'Contain at least 1 uppercase letter',
      lowercase: 'Contain at least 1 lowercase letter',
      special: 'Contain at least 1 special character',
      number: 'Contain at least 1 number',
    },
    invalidInvite: 'This invitation is no longer valid. Please contact your organisation admin.',
  },
  accountSetup: {
    title: 'Account setup',
    subtitle: 'How do you plan on using Budget Control by BOQNET? Please select an option below.',
    checkEmailTitle: 'Please check your email',
    checkEmailSubtitle:
      'We’ve sent a verification link to your registered email address. Please close this tab and follow the link in the email to complete registration.',
    verifiedTitle: 'Email verified',
    verifiedSubtitle: 'Thank you for verifying your email. Please click the button to continue.',
    verifiedSignInSubtitle:
      'Your email is verified and your account is active. Please sign in to continue.',
    verifyFailedTitle: 'Verification link invalid or expired',
    verifyFailedSubtitle:
      'We could not verify your email with that link. Request a new one below, or contact your administrator if the issue persists.',
    unverifiedSignInTitle: 'Confirm your email to sign in',
    unverifiedSignInSubtitle:
      'Your password is correct, but this account is still waiting on email confirmation. Follow the link we sent you, or request a new one below.',
    resendEmail: 'Resend email',
    resendEmailIn: 'Resend email in {seconds}s',
    emailResent: 'Email sent',
    personalTitle: 'Personal',
    personalBody:
      'Your own personal workspace. You can create or join organisations at a later stage.',
    orgTitle: 'Create an organisation',
    orgBody:
      'Add your organisation details and compliance documentation. Invite users to your organisation to assign to projects.',
    organisation: {
      subtitle: 'Please complete the details below.',
      subtitleSkip:
        'Please complete the details below. You can skip if you don’t have this information on hand.',
      name: {
        title: 'Organisation name',
      },
      details: {
        title: 'Organisation details',
      },
      compliance: {
        title: 'Organisation compliance',
        uploadVat: 'Upload VAT doc',
        uploadProof: 'Upload proof of address',
      },
    },
  },
  forgotPassword: {
    title: 'Forgot Password',
    step1: 'Please enter your registered email address below to reset your password.',
    step2:
      'We’ve sent you a reset password link.\n Please check your email and follow the instructions.',
    step3: 'If you have not received an email, please contact your administrator.',
    step4: 'Go back to previous screen',
    sendReset: 'Send reset link',
    resendReset: 'Resend reset password link',
    toasts: {
      linkSent: {
        title: 'Reset link sent',
      },
      linkResent: {
        title: 'Reset link resent',
      },
    },
  },
  resetPassword: {
    start: {
      title: 'Reset Password',
      subtitle: 'Please enter your new password below.',
    },
    success: {
      title: 'Password Successfully Reset',
      subtitle: 'Please sign in using your email and new password.',
    },
    validationFailed: {
      title: 'Invalid or expired token',
      subtitle: 'Please try again or contact your administrator if the issue persists.',
    },
  },
  signIn: 'Sign in',
  returnToLogin: 'Return to sign in',
  createAccount: 'Create Account',
  confirm: 'Confirm',
  forgotPw: 'Forgot password?',
  form: {
    email: 'Email address',
    password: 'Password',
    passwordSet: 'Set your password',
    passwordNew: 'Enter new password',
    firstname: 'First name',
    lastname: 'Last name',
    organisation: 'Organisation name',
    legalCheckbox: 'I agree and accept the {0}',
    legalDocs: 'EULA, Terms and conditions and Privacy Policy',
  },
};
